import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const getUserToken = () => {
  const cookieValue = document.cookie
    .split("; ")
    .find((row) => row.startsWith("_auth"))
      ?.split("=")[1];
      
  return cookieValue ? decodeURIComponent(cookieValue) : null;
};

export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: "https://www.transitionnumeriquedz.com/api",
    /* baseUrl: "http://127.0.0.1:5500", */
    prepareHeaders: (headers) => {
      headers.set("Content-Type", "application/json");
      headers.set("Authorization", getUserToken());
      return headers;
    }
  }),
  reducerPath: "adminApi",
  tagTypes: ["User", "CheckEmailPseudo", "ContactForm"],
  endpoints: (build) => ({
    getUser: build.query({
      query: (id) => `user/${id}`,
      providesTags: ["User"],
    }),
    checkEmailPseudo: build.query({
      query: ({ email, pseudo }) => ({
        url: "user/check-email-pseudo",
        method: "POST",
        params: { email, pseudo },
      }),
      providesTags: ["CheckEmailPseudo"],
    }),
    getUserFullInfo: build.query({
      query: (id) => `user/${id}/full-info`,
      providesTags: ["User"],
    }),
    updateUserPass: build.mutation({
      query: ({ userId, passType, paymentStatus, workshop }) => ({
        url: `user/${userId}/update-pass`,
        method: "PATCH",
        body: {
          passType,
          paymentStatus,
          workshop,
        },
      }),
      invalidatesTags: ["User"],
    }),
    // New mutation for sending contact form data
    sendContactForm: build.mutation({
      query: ({ name, email, subject, message }) => ({
        url: "contact/submit",
        method: "POST",
        body: {
          name,
          email,
          subject,
          message,
        },
      }),
      invalidatesTags: ["ContactForm"], // Update this if you have other related tags to invalidate
    }),
  }),
});

export const {
  useGetUserQuery,
  useLazyCheckEmailPseudoQuery,
  useUpdateUserPassMutation,
  useGetUserFullInfoQuery,
  useSendContactFormMutation // Export the mutation hook for use in your component
} = api;
